export class Request {
    public static getParameter(parameter: string): string {
        const regex: RegExp = new RegExp("[\\?&]" + parameter + "=([^&#]*)");
        const regexResult: RegExpExecArray | null = regex.exec(location.search);
        return Array.isArray(regexResult) ? decodeURIComponent(regexResult[1].replace(/\+/g, " ")) : "";
    }
}
